import { useNavigate } from "react-router-dom";

import { Button } from "@components/Button";
import { ButtonType } from "@components/Button/types";
import { Overlay } from "@components/Overlay";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, H2 } from "@components/Typography";
import { Routes } from "@ctypes";
import { useAllocateFundsFlow, useModal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { formatCurrency } from "@utils/formatter";
import { CheckMark } from "./CheckMark";
import { styles } from "./styles";
import { AllocateFundsSuccessModalProps } from "./types";

export const AllocateFundsSuccessModal = ({
  allocatedAmount: allocatedAmountValue,
  remainingAmount: remainingAmountValue,
  name,
  callback,
}: AllocateFundsSuccessModalProps) => {
  const navigate = useNavigate();
  const { dismiss } = useModal();

  const { clearAllocateFundsProps } = useAllocateFundsFlow();

  const allocatedAmount = formatCurrency(allocatedAmountValue);
  const remainingAmount = formatCurrency(remainingAmountValue);

  const handleSubmit = () => {
    dismiss();
    navigate(Routes.Dashboard);
  };

  const handleContinueAllocating = () => {
    clearAllocateFundsProps();
    dismiss();
    callback?.();
  };

  return (
    <Overlay>
      <CheckMark />
      <Spacing size={SpacingSizes.M} />

      <H2 style={styles.text}>Funds allocated</H2>
      <Spacing size={SpacingSizes.M} />

      <Body style={styles.text}>
        {i18n.t(Translations.AllocateFundsSuccessScreenSubtitle, {
          allocatedAmount,
          name,
          remainingAmount,
        })}
      </Body>
      <Spacing size={SpacingSizes.M} />

      <Button
        title={i18n.t(Translations.AllocateFundsSuccessScreenPrimaryCTA)}
        onClick={handleSubmit}
      />
      <Spacing size={SpacingSizes.XS} />

      <Button
        title={i18n.t(Translations.AllocateFundsSuccessScreenSecondaryCTA)}
        type={ButtonType.Inverse}
        onClick={handleContinueAllocating}
      />
    </Overlay>
  );
};
